// Colores propios de Reportes v2.
// Se mantienen como constantes nombradas en lugar de reemplazarse por valores del theme
// porque cada uno tiene una razón documentada abajo.

// Fondo del componente InnerPaper (panel interior dentro de diálogos).
// Semánticamente debería ser theme.palette.background.default (#171c24), que representa
// una superficie recesada respecto al fondo del diálogo (background.paper = #222b36).
// Se mantiene el valor original porque cae entre ambos (#1E262F = RGB 30,38,47) y produce
// el contraste visual deliberado que background.default no reproduce exactamente.
export const INNER_PAPER_BG = '#1E262F';

// Fondo de hover en filas y botones de lista.
// El equivalente en theme es theme.palette.action.hover = rgba(255,255,255,0.04).
// El valor actual (#ffffff10 = rgba(255,255,255,0.063)) es ligeramente más intenso,
// lo que mejora la legibilidad en el contexto oscuro de estos componentes.
export const ROW_HOVER_BG = '#ffffff10';

// Fondo del header de la columna "Acciones" en ReportTemplatesTable.
// No tiene equivalente directo en el theme. El más cercano es background.opacity (#29425f),
// pero es más saturado/azulado. Este valor (#374454) es más neutro y funciona mejor como
// diferenciador visual de la columna de acciones sin llamar demasiado la atención.
export const ACTIONS_HEADER_BG = '#374454';

// Colores del botón de descarga Excel — verde oficial de branding de Microsoft Excel.
// theme.palette.success es teal (#6FBCB3), incompatible visualmente con Excel.
// @mui/material/colors green[800] = #2e7d32, difiere notablemente del verde Excel real (#1d6f42).
// Se mantienen como constante de branding de tercero, análogo al uso de red[700/900]
// para el botón PDF en ReportHistory.tsx.
export const EXCEL_GREEN = {
  main: '#1d6f42',
  dark: '#195e38',
};
